const TEST_CONSTANTS = {
  test: 'test',
};

export {TEST_CONSTANTS};
